import { render, staticRenderFns } from "./targeting.vue?vue&type=template&id=feaf9210&scoped=true"
import script from "./targeting.vue?vue&type=script&lang=js"
export * from "./targeting.vue?vue&type=script&lang=js"
import style0 from "./targeting.vue?vue&type=style&index=0&id=feaf9210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaf9210",
  null
  
)

export default component.exports